import request from "../Config/axios";

// -----------------------------------------------------------
export const GetAll_Object_Field_Value_Api = async (objectInstanceId) => {
    const { data } = await request.get(
        `/Object_Field_Value/GetAll/?objectInstanceId=` + objectInstanceId,
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Active_Object_Field_Value_Api = async (objectInstanceId) => {
    const { data } = await request.get(
        `/Object_Field_Value/GetAll_Active/?objectInstanceId=` + objectInstanceId,
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_Object_Field_Value_Api = async (id) => {
    const { data } = await request.delete(
        `/Object_Field_Value/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Object_Field_Value_Api = async (params) => {
    const { data } = await request.post(
        `/Object_Field_Value/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Object_Field_Value_Api = async (params) => {
    const { data } = await request.post(
        `/Object_Field_Value/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------